/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from '@tanstack/react-query';

import type {
	AdminLoginResponseDto,
	AdminResponseDto,
	ChangePasswordDto,
	ChangePasswordResponseDto,
	CheckEmailDto,
	CheckEmailResponseDto,
	FindAdminEmailDto,
	FindAdminEmailResponseDto,
	InitialPasswordChangeDto,
	InitialPasswordChangeResponseDto,
	LoginDto,
	RegisterAdminDto,
	ResetAdminPasswordDto,
	ResetAdminPasswordResponseDto,
	UnlockAccountDto,
	UnlockAccountResponseDto,
} from '../model';

import { axiosInstance } from '../../axiosInstance';

/**
 * 관리자 등록 시 이메일 중복 여부 확인
 * @summary 이메일 중복 확인
 */
export const adminsControllerCheckEmailV1 = (checkEmailDto: CheckEmailDto, signal?: AbortSignal) => {
	return axiosInstance<CheckEmailResponseDto>({
		url: `/v1/admins/check-email`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: checkEmailDto,
		signal,
	});
};

export const getAdminsControllerCheckEmailV1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>,
		TError,
		{ data: CheckEmailDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>,
	TError,
	{ data: CheckEmailDto },
	TContext
> => {
	const mutationKey = ['adminsControllerCheckEmailV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>,
		{ data: CheckEmailDto }
	> = (props) => {
		const { data } = props ?? {};

		return adminsControllerCheckEmailV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerCheckEmailV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>
>;
export type AdminsControllerCheckEmailV1MutationBody = CheckEmailDto;
export type AdminsControllerCheckEmailV1MutationError = unknown;

/**
 * @summary 이메일 중복 확인
 */
export const useAdminsControllerCheckEmailV1 = <TError = unknown, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>,
			TError,
			{ data: CheckEmailDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>,
	TError,
	{ data: CheckEmailDto },
	TContext
> => {
	return useMutation(getAdminsControllerCheckEmailV1MutationOptions(options), queryClient);
};
/**
 * 새로운 관리자 등록
 * @summary 관리자 등록
 */
export const adminsControllerRegisterV1 = (registerAdminDto: RegisterAdminDto, signal?: AbortSignal) => {
	return axiosInstance<AdminLoginResponseDto>({
		url: `/v1/admins/register`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: registerAdminDto,
		signal,
	});
};

export const getAdminsControllerRegisterV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerRegisterV1>>,
		TError,
		{ data: RegisterAdminDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerRegisterV1>>,
	TError,
	{ data: RegisterAdminDto },
	TContext
> => {
	const mutationKey = ['adminsControllerRegisterV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerRegisterV1>>,
		{ data: RegisterAdminDto }
	> = (props) => {
		const { data } = props ?? {};

		return adminsControllerRegisterV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerRegisterV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerRegisterV1>>
>;
export type AdminsControllerRegisterV1MutationBody = RegisterAdminDto;
export type AdminsControllerRegisterV1MutationError = void;

/**
 * @summary 관리자 등록
 */
export const useAdminsControllerRegisterV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerRegisterV1>>,
			TError,
			{ data: RegisterAdminDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerRegisterV1>>,
	TError,
	{ data: RegisterAdminDto },
	TContext
> => {
	return useMutation(getAdminsControllerRegisterV1MutationOptions(options), queryClient);
};
/**
 * @summary 관리자 로그인
 */
export const adminsControllerLoginV1 = (loginDto: LoginDto, signal?: AbortSignal) => {
	return axiosInstance<AdminLoginResponseDto>({
		url: `/v1/admins/login`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: loginDto,
		signal,
	});
};

export const getAdminsControllerLoginV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerLoginV1>>,
		TError,
		{ data: LoginDto },
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerLoginV1>>, TError, { data: LoginDto }, TContext> => {
	const mutationKey = ['adminsControllerLoginV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerLoginV1>>, { data: LoginDto }> = (
		props,
	) => {
		const { data } = props ?? {};

		return adminsControllerLoginV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerLoginV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerLoginV1>>>;
export type AdminsControllerLoginV1MutationBody = LoginDto;
export type AdminsControllerLoginV1MutationError = void;

/**
 * @summary 관리자 로그인
 */
export const useAdminsControllerLoginV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerLoginV1>>,
			TError,
			{ data: LoginDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerLoginV1>>, TError, { data: LoginDto }, TContext> => {
	return useMutation(getAdminsControllerLoginV1MutationOptions(options), queryClient);
};
/**
 * 현재 로그인한 관리자 정보 조회 (권한 포함)
 * @summary 내 정보 조회
 */
export const adminsControllerGetMyProfileV1 = (signal?: AbortSignal) => {
	return axiosInstance<AdminResponseDto>({ url: `/v1/admins/me`, method: 'GET', signal });
};

export const getAdminsControllerGetMyProfileV1QueryKey = () => {
	return [`/v1/admins/me`] as const;
};

export const getAdminsControllerGetMyProfileV1QueryOptions = <
	TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
	TError = void,
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getAdminsControllerGetMyProfileV1QueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>> = ({ signal }) =>
		adminsControllerGetMyProfileV1(signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminsControllerGetMyProfileV1QueryResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>
>;
export type AdminsControllerGetMyProfileV1QueryError = void;

export function useAdminsControllerGetMyProfileV1<
	TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
	TError = void,
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerGetMyProfileV1<
	TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
	TError = void,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerGetMyProfileV1<
	TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
	TError = void,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 내 정보 조회
 */

export function useAdminsControllerGetMyProfileV1<
	TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
	TError = void,
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getAdminsControllerGetMyProfileV1QueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * 이름과 휴대폰 번호로 관리자 이메일 찾기
 * @summary 관리자 이메일 찾기
 */
export const adminsControllerFindEmailV1 = (findAdminEmailDto: FindAdminEmailDto, signal?: AbortSignal) => {
	return axiosInstance<FindAdminEmailResponseDto>({
		url: `/v1/admins/find-email`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: findAdminEmailDto,
		signal,
	});
};

export const getAdminsControllerFindEmailV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerFindEmailV1>>,
		TError,
		{ data: FindAdminEmailDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerFindEmailV1>>,
	TError,
	{ data: FindAdminEmailDto },
	TContext
> => {
	const mutationKey = ['adminsControllerFindEmailV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerFindEmailV1>>,
		{ data: FindAdminEmailDto }
	> = (props) => {
		const { data } = props ?? {};

		return adminsControllerFindEmailV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerFindEmailV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerFindEmailV1>>
>;
export type AdminsControllerFindEmailV1MutationBody = FindAdminEmailDto;
export type AdminsControllerFindEmailV1MutationError = void;

/**
 * @summary 관리자 이메일 찾기
 */
export const useAdminsControllerFindEmailV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerFindEmailV1>>,
			TError,
			{ data: FindAdminEmailDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerFindEmailV1>>,
	TError,
	{ data: FindAdminEmailDto },
	TContext
> => {
	return useMutation(getAdminsControllerFindEmailV1MutationOptions(options), queryClient);
};
/**
 * 이메일, 이름, 휴대폰 번호로 임시 비밀번호 발급 (만료시간 5분)
 * @summary 1회용 비밀번호 발급
 */
export const adminsControllerResetPasswordV1 = (resetAdminPasswordDto: ResetAdminPasswordDto, signal?: AbortSignal) => {
	return axiosInstance<ResetAdminPasswordResponseDto>({
		url: `/v1/admins/reset-password`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: resetAdminPasswordDto,
		signal,
	});
};

export const getAdminsControllerResetPasswordV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
		TError,
		{ data: ResetAdminPasswordDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
	TError,
	{ data: ResetAdminPasswordDto },
	TContext
> => {
	const mutationKey = ['adminsControllerResetPasswordV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
		{ data: ResetAdminPasswordDto }
	> = (props) => {
		const { data } = props ?? {};

		return adminsControllerResetPasswordV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerResetPasswordV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>
>;
export type AdminsControllerResetPasswordV1MutationBody = ResetAdminPasswordDto;
export type AdminsControllerResetPasswordV1MutationError = void;

/**
 * @summary 1회용 비밀번호 발급
 */
export const useAdminsControllerResetPasswordV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
			TError,
			{ data: ResetAdminPasswordDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
	TError,
	{ data: ResetAdminPasswordDto },
	TContext
> => {
	return useMutation(getAdminsControllerResetPasswordV1MutationOptions(options), queryClient);
};
/**
 * 마스터 관리자가 잠금된 관리자 계정을 해제 (본인 비밀번호 필요)
 * @summary 관리자 계정 잠금 해제 (마스터 관리자 전용)
 */
export const adminsControllerUnlockAccountV1 = (unlockAccountDto: UnlockAccountDto, signal?: AbortSignal) => {
	return axiosInstance<UnlockAccountResponseDto>({
		url: `/v1/admins/unlock-account`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: unlockAccountDto,
		signal,
	});
};

export const getAdminsControllerUnlockAccountV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>,
		TError,
		{ data: UnlockAccountDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>,
	TError,
	{ data: UnlockAccountDto },
	TContext
> => {
	const mutationKey = ['adminsControllerUnlockAccountV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>,
		{ data: UnlockAccountDto }
	> = (props) => {
		const { data } = props ?? {};

		return adminsControllerUnlockAccountV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerUnlockAccountV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>
>;
export type AdminsControllerUnlockAccountV1MutationBody = UnlockAccountDto;
export type AdminsControllerUnlockAccountV1MutationError = void;

/**
 * @summary 관리자 계정 잠금 해제 (마스터 관리자 전용)
 */
export const useAdminsControllerUnlockAccountV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>,
			TError,
			{ data: UnlockAccountDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>,
	TError,
	{ data: UnlockAccountDto },
	TContext
> => {
	return useMutation(getAdminsControllerUnlockAccountV1MutationOptions(options), queryClient);
};
/**
 * 비밀번호 변경 180일 경과 또는 임시 비밀번호 발급 상태에서 현재 비밀번호와 새 비밀번호로 변경 (기존 세션 무효화)
 * @summary 관리자 비밀번호 변경
 */
export const adminsControllerChangePasswordV1 = (changePasswordDto: ChangePasswordDto, signal?: AbortSignal) => {
	return axiosInstance<ChangePasswordResponseDto>({
		url: `/v1/admins/change-password`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: changePasswordDto,
		signal,
	});
};

export const getAdminsControllerChangePasswordV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
		TError,
		{ data: ChangePasswordDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
	TError,
	{ data: ChangePasswordDto },
	TContext
> => {
	const mutationKey = ['adminsControllerChangePasswordV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
		{ data: ChangePasswordDto }
	> = (props) => {
		const { data } = props ?? {};

		return adminsControllerChangePasswordV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerChangePasswordV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>
>;
export type AdminsControllerChangePasswordV1MutationBody = ChangePasswordDto;
export type AdminsControllerChangePasswordV1MutationError = void;

/**
 * @summary 관리자 비밀번호 변경
 */
export const useAdminsControllerChangePasswordV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
			TError,
			{ data: ChangePasswordDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
	TError,
	{ data: ChangePasswordDto },
	TContext
> => {
	return useMutation(getAdminsControllerChangePasswordV1MutationOptions(options), queryClient);
};
/**
 * 최초 관리자 계정 생성 또는 임시 비밀번호 발급 후 새 비밀번호로 변경 (현재 비밀번호 불필요, 기존 세션 무효화)
 * @summary 최초 비밀번호 변경
 */
export const adminsControllerChangeInitialPasswordV1 = (
	initialPasswordChangeDto: InitialPasswordChangeDto,
	signal?: AbortSignal,
) => {
	return axiosInstance<InitialPasswordChangeResponseDto>({
		url: `/v1/admins/change-initial-password`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: initialPasswordChangeDto,
		signal,
	});
};

export const getAdminsControllerChangeInitialPasswordV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
		TError,
		{ data: InitialPasswordChangeDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
	TError,
	{ data: InitialPasswordChangeDto },
	TContext
> => {
	const mutationKey = ['adminsControllerChangeInitialPasswordV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
		{ data: InitialPasswordChangeDto }
	> = (props) => {
		const { data } = props ?? {};

		return adminsControllerChangeInitialPasswordV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerChangeInitialPasswordV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>
>;
export type AdminsControllerChangeInitialPasswordV1MutationBody = InitialPasswordChangeDto;
export type AdminsControllerChangeInitialPasswordV1MutationError = void;

/**
 * @summary 최초 비밀번호 변경
 */
export const useAdminsControllerChangeInitialPasswordV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
			TError,
			{ data: InitialPasswordChangeDto },
			TContext
		>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
	TError,
	{ data: InitialPasswordChangeDto },
	TContext
> => {
	return useMutation(getAdminsControllerChangeInitialPasswordV1MutationOptions(options), queryClient);
};
